<template>
  <div class="cs-signIn-courseMerge">
    <el-row
      class="text-center"
      v-if="dataIn.scope.row.StudentId>0"
    >
      <el-row
        :gutter="24"
        class="select-sign-in-type-row select-sign-in-type-row-first"
      >
        <el-row>
          <el-row v-if="modelData.SignInType ==0">
            <i class="el-icon-minus icon-not-sign-color icon-make-sign"></i>
            <!-- <span>{{getMergeColumn(scope,course).SignInTimeText}}</span> -->
          </el-row>
          <el-row v-if="modelData.SignInType ==1">
            <i class="el-icon-check icon-color icon-make-sign"></i>
            <!-- <span>{{getMergeColumn(scope,course).SignInTimeText}}</span> -->
          </el-row>
          <el-row v-if="modelData.SignInType==2">
            <span class="make-sign-late">缺时{{modelData.LateMinutes}}M</span>
          </el-row>
          <el-row v-if="modelData.SignInType==3">
            <span class="make-sign-late">缺课</span>
          </el-row>
          <el-row v-if="modelData.SignInType==4">
            <span class="make-sign-late ">旷课</span>
          </el-row>
          <el-row v-if="modelData.SignInType==5">
            <span class="cs-color-frenchgrey">退课</span>
          </el-row>
          <el-row v-if="modelData.SignInType==6">
            <span class="cs-color-frenchgrey">视频课</span>
          </el-row>
        </el-row>
      </el-row>
      <el-row
        :gutter="24"
        class="select-sign-in-type-row"
      >
        <span class="sign-remark">{{modelData.Comment}}</span>
      </el-row>
    </el-row>
    <el-row
      class="text-center"
      v-if="dataIn.scope.row.StudentId<0"
    >
      <el-row>
        <span>
          <span>{{getMergeAttendanceCount(dataIn.scope, dataIn.group)}} / {{getMergeTotalCount(dataIn.scope, dataIn.group)}}</span>
        </span>
      </el-row>
      <el-row class="course-time">
        <span>
          课时：{{getMergeTotalMinitues(dataIn.scope,dataIn.group)}}分钟
        </span>
      </el-row>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-signIn-courseMerge{


  .select-sign-in-type-row {
    padding-left: 5px;
    padding-right: 5px;
  }
  .select-sign-in-type-row-first {
    padding-top: 10px;
  }
  .sign-remark {
    color: #b4b4b4;
    font-size: 12px;
  }
  .icon-make-sign {
    font-weight: bolder;
    font-size: 18px;
  }
  .icon-not-sign-color {
    color: red;
  }
  .text-center {
    text-align: center;
  }
  .course-time {
    color: #207cbd;
  }
}
</style>

<script>
import global_ from "@/core/global";

export default {
  components: {},
  props: {
    dataIn: {
      isView: Boolean,
      scope: Object,
      group: Object,
      week: Object,
      tableData: Object
    }
  },
  data() {
    return {
      signTypes: [
        {
          Id: 1,
          Label: "正常"
        },
        {
          Id: 2,
          Label: "缺时"
        },
        {
          Id: 3,
          Label: "缺课"
        },
        {
          Id: 4,
          Label: "旷课"
        }
      ],
      modelData: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.modelData = this.getMergeColumn(
        this.dataIn.scope,
        this.dataIn.group
      );
    },
    getMergeColumn(scope, group) {
      let returnCourse = {
        SignInType: 0,
        Comment: ""
      };
      let types = [];

      group.forEach(course => {
        let studentCourse = this.getStudentSign(scope, course);
        types.push(studentCourse);
      });

      let type1 = types.find(r => r.SignInType == 1);
      if (type1) {
        //存在正常签到
        returnCourse = {
          SignInType: 1,
          Comment: type1.Comment
        };

        return returnCourse;
      }

      let type2 = types.find(r => r.SignInType == 2);
      if (type2) {
        //存在迟到签到
        returnCourse = {
          SignInType: 2,
          LateMinutes: type2.LateMinutes,
          Comment: type2.Comment
        };

        return returnCourse;
      }

      let type4 = types.find(r => r.SignInType == 4);
      if (type4) {
        //存在旷课签到
        returnCourse = {
          SignInType: 4,
          Comment: type4.Comment
        };

        return returnCourse;
      }

      let type3 = types.find(r => r.SignInType == 3);
      if (type3) {
        //存在缺课签到
        returnCourse = {
          SignInType: 3,
          Comment: type3.Comment
        };

        return returnCourse;
      }

      let type5 = types.find(r => r.SignInType == 5);
      if (type5) {
        //存在旷课签到
        returnCourse = {
          SignInType: 5,
          Comment: ""
        };

        return returnCourse;
      }

      return returnCourse;
    },
    getStudentSign(scope, courseActivation) {
      var row = scope.row.SignInMgtStudentSignInList.find(
        r => r.CourseActivationId == courseActivation.CourseActivationId
      );

      if (!row) {
        let signIntype = 4; // 大于报名日期是旷课4
        if (courseActivation.IsActive) {
          signIntype = 0;
        } else {
          let scourseTime = new Date(scope.row.StudentCourseStartTime);
          let activeTime = new Date(courseActivation.ActiveTime);
    
          if (activeTime < scourseTime) {
            //小于报名日期是缺课3
            signIntype = 3;
            //debugger;
          }else{
            if (this.checkIsRefund(activeTime, scope.row)){
              signIntype = 5;
            }

            //如果不是退课，需要判断是否视频课
            if (signIntype != 5){
              if (!!scope.row.IsVideoFree ){
                signIntype = 6;
              }
            }
          }
        }

        var addRow = {
          CourseActivationId: courseActivation.CourseActivationId,
          IsEditing: false,
          SignInType: signIntype
        };
        scope.row.SignInMgtStudentSignInList.push(addRow);

        return addRow;
      }
      return row;
    },
    checkIsRefund(activeTime, row){
      let isRefund = false;
      if ( row.HasRefund ) {
        let count = row.SignInCourseList.length;
        if ( row.SignInCourseList[count - 1].IsRefund ) {
          let refundTime = new Date(row.SignInCourseList[count - 1].RefundTime);
          if ( activeTime > refundTime ) {
            isRefund = true;
          }
        }
        if ( count > 1 ) {
          let lastRefundTime = null;
    
          for ( let i = 0; i < count; i++ ) {
            let item = row.SignInCourseList[i];
            let completedTime = new Date(item.CompletedTime);
            if ( !!lastRefundTime && activeTime > lastRefundTime && activeTime < completedTime ) {
              isRefund = true;
              break;
            }
            
            if (!!item.RefundTime){
              lastRefundTime =  new Date(item.RefundTime);
            }
          }
        } 
      }
      return isRefund;
    },
    getMergeTotalCount(scope, group) {
      let types = [];
      let count = 0;

      let studentList = this.dataIn.tableData.SignInMgtStudentList;
     
      group.forEach(course => {
        let id = course.CourseActivationId;

        studentList.forEach(s => {
          if (s.StudentId <= 0) {
            return;
          }
          if (
            s.SignInMgtStudentSignInList.findIndex(
              s =>
                s.CourseActivationId == id &&
                (s.SignInType == 1 || s.SignInType == 2 || s.SignInType == 4)
            ) > -1
          ) {
            if (types.findIndex(t => t.StudentId == s.StudentId) < 0) {
              types.push({
                StudentId: s.StudentId
              });
              count++;
            }
          }
        });
      });

      return count;
    },
    getMergeAttendanceCount(scope, group) {
      let types = [];
      let count = 0;

      let studentList = this.dataIn.tableData.SignInMgtStudentList;

      group.forEach(course => {
        let id = course.CourseActivationId;

        studentList.forEach(s => {
          if (s.StudentId <= 0) {
            return;
          }
          if (
            s.SignInMgtStudentSignInList.findIndex(
              s =>
                s.CourseActivationId == id &&
                (s.SignInType == 1 || s.SignInType == 2)
            ) > -1
          ) {
            if (types.findIndex(t => t.StudentId == s.StudentId) < 0) {
              types.push({
                StudentId: s.StudentId
              });
              count++;
            }
          }
        });
      });

      return count;
    },
    getMergeTotalMinitues(scope, group) {
      let total = 0;
      let minitues = 0;

      if (group && group.length > 0) {
        group.forEach(g => {
          total += parseInt(g.CourseMinutes);
        });
        minitues = total / group.length;
      }

      return minitues;
    },
  },
  watch: {
    dataIn: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/signInManage/signInMangeMergeCourse.vue